import {
  chatsCollection,
  usersCollection,
  firebase,
  storage,
} from "../../config/firebase";

let state = {
  chat: {},
  chats: [],
  loading: false,
  notification: { message: "", type: "" },
};
let getters = {
  chat: (state) => state.chat,
  chats: (state) => state.chats,
  chatLoading: (state) => state.loading,
  chatNotification: (state) => state.notification,
};
let actions = {
  async getChat({ commit }, payload) {
    commit("setChatLoading", true);
    chatsCollection
      .doc(payload)
      .collection("messages")
      .orderBy("datetime", "asc")
      .onSnapshot(async (snapshot) => {
        let chatData = [];
        for (let chat of snapshot.docs) {
          let data = chat.data();
          let userSnap = await usersCollection.doc(data.sender).get();
          let userData = userSnap.data();
          data["name"] = userData.firstname + userData.lastname;
          chatData.push({ ...data });
        }
        commit("setChatData", chatData);
        commit("setChatLoading", false);
      });
  },
  async getChats({ commit }, payload) {
    
    commit("setChatLoading", true);
    chatsCollection
      .where("participants", "array-contains", payload)
      .onSnapshot(async (snapshot) => {
        let chats = [];
        for (let doc of snapshot.docs) {
          let data = doc.data();
          if (!data.deletedBy.includes(payload)) {
            let { participants } = data;
            if (data.type == "single") {
              let participant = participants.find(
                (participant) => participant != payload
              );
              let userSnap = await usersCollection.doc(participant).get();
              let userData = userSnap.data();
              if (userData && userData.firstname) {
                
                data["participant_id"] = participant;
                data["name"] = userData.firstname + " " + userData.lastname;
                if (userData.profile_image)
                  data["profile_image"] = userData.profile_image;
              }
            } else {
              let tempParticipant = {};
              let i = 0;
              for (let participant of participants) {
                let userSnap = await usersCollection.doc(participant).get();
                let userData = userSnap.data();
                console.table(userData);
                tempParticipant = {
                  name: userData.firstname + " " + userData.lastname,
                  profile_image: userData.profile_image,
                  id: userSnap.id,
                };
                participants[i++] = tempParticipant;
              }
              data["participants"] = participants;
            }
            chats.push({ id: doc.id, ...data });
          }
        }

        commit("setChatsData", chats);
        commit("setChatLoading", false);
      });
  },
  async sendMessage({ commit }, payload) {
    let chat_id = chatsCollection.doc().id;
    commit("setChatLoading", true);
    let { isAlreadyChat, attachment } = payload;
    if (!isAlreadyChat) {
      let obj = {
        datetime: firebase.firestore.Timestamp.fromDate(new Date()),
        participants: [...payload.reciever, payload.sender],
        type: payload.type,
        deletedBy: [],
      };
      if (payload["name"]) {
        obj["name"] = payload["name"];
        obj["owner_id"] = payload["owner_id"];
      }
      await chatsCollection.doc(chat_id).set({ ...obj });
    } else {
      chat_id = payload.chat_id;
      delete payload.chat_id;
    }
    delete payload.reciever;
    delete payload.isURLChat;
    delete payload.isAlreadyChat;
    delete payload.type;
    if (attachment != undefined) {
      let unique_id = chatsCollection.doc().id;
      let parts = attachment.name.split(".");
      let fileExt = parts[parts.length - 1];
      let filename = unique_id + "." + fileExt;
      let type = attachment.type.split("/")[0];
      await storage
        .ref("chat_attachment")
        .child(filename)
        .put(attachment);
      let url = await storage
        .ref("chat_attachment")
        .child(filename)
        .getDownloadURL();
      payload["attachment"] = {
        url,
        type,
      };
    }
    let data = {
      ...payload,
      datetime: firebase.firestore.Timestamp.fromDate(new Date()),
    };

    await chatsCollection
      .doc(chat_id)
      .collection("messages")
      .add({ ...data });

    commit("setChatLoading", false);
  },
  async deleteChat({ commit }, payload) {
    let { chat_id, user_id } = payload;
    let chatSnap = await chatsCollection.doc(chat_id).get();
    let chatData = chatSnap.data();
    let { deletedBy } = chatData;
    deletedBy.push(user_id);
    chatData["deletedBy"] = deletedBy;
    await chatsCollection.doc(chat_id).update({ ...chatData });
  },
  async removeChatMember({ commit }, payload) {
    commit("setChatLoading", true);
    
    let chatSnap = await chatsCollection.doc(payload.chat_id).get();
    let chatData = chatSnap.data();
    let { participants } = chatData;
    participants = participants.filter(
      (participant) => participant != payload.participant
    );
    chatData["participants"] = participants;
    chatsCollection.doc(payload.chat_id).update({ ...chatData });
    commit("setChatLoading", false);
  },
};
let mutations = {
  setChatData(state, payload) {
    state.chat = payload;
  },
  setChatsData(state, payload) {
    state.chats = payload;
  },
  setFeaturedChatsData(state, payload) {
    state.featuredChats = payload;
  },
  setChatLoading(state, payload) {
    state.loading = payload;
  },
  setChatsNotification(state, payload) {
    let { notification } = state;
    notification.message = payload.message;
    notification.type = payload.type;
    state.notification = notification;
    window.setTimeout(() => {
      let obj = { message: "", type: "" };
      state.notification = obj;
    }, 5000);
  },
};
export default { state, getters, actions, mutations };
